import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { quizs } from '../Data/E_Offer';

const AttemptQuiz = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const quiz = quizs.find((item) => item.id === Number(id));

  const [selectedAnswers, setSelectedAnswers] = useState({});

  // ✅ TIMER STATE
  const totalMinutes = quiz.questions.length; // 1 minute per question
  const [timeLeft, setTimeLeft] = useState(totalMinutes * 60);

  // ✅ TIMER EFFECT
  useEffect(() => {
    if (timeLeft <= 0) {
      handleSubmit();
      return;
    }

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  // ✅ FORMAT TIME (MM:SS)
  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleChange = (questionIndex, optionIndex) => {
    setSelectedAnswers((prev) => {
      const prevAnswers = prev[questionIndex] || [];

      if (prevAnswers.includes(optionIndex)) {
        return {
          ...prev,
          [questionIndex]: prevAnswers.filter(
            (item) => item !== optionIndex
          ),
        };
      } else {
        return {
          ...prev,
          [questionIndex]: [...prevAnswers, optionIndex],
        };
      }
    });
  };

  const handleSubmit = () => {
    console.log("User Answers:", selectedAnswers);
    alert("Quiz Submitted!");
    navigate("/quiz");
  };

  return (
    <div className="flex flex-col gap-[1rem] justify-center items-center px-[4rem] py-[5rem]">

      {/* Header */}
      <div className="flex justify-between items-center w-full p-3 shadow-[0px_7px_29px_0px_rgba(100,100,111,0.2)]">
        <h1 className='font-bold text-[1.4rem]'>{quiz.title}</h1>

        <div className='flex gap-[0.4rem]'>
          <h2 className='font-bold text-[1.2rem] text-gray-500'>Time Left:</h2>
          <h2 className='font-bold text-[1.2rem] text-red-500'>
            {formatTime()}
          </h2>
        </div>
      </div>

      {/* Description */}
      <div className="w-full">
        <div className="w-full p-[2rem] shadow-[0px_7px_29px_0px_rgba(100,100,111,0.2)] mb-6">
          <p className="font-light text-[1.2rem] text-gray-500">
            {quiz.description}
          </p>
        </div>

        {/* Questions */}
        <div className="flex flex-col gap-6">

          {quiz.questions.map((question, qIndex) => (
            <div key={qIndex} className="p-5 rounded-xl shadow-md bg-white">
              <h2 className="font-semibold text-lg mb-4">
                {qIndex + 1}. {question.questionText}
              </h2>

              <div className="flex flex-wrap gap-6">
                {question.options.map((option, oIndex) => (
                  <label key={oIndex} className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={selectedAnswers[qIndex]?.includes(oIndex) || false}
                      onChange={() => handleChange(qIndex, oIndex)}
                    />
                    <span>{option}</span>
                  </label>
                ))}
              </div>
            </div>
          ))}

          {/* Buttons */}
          <div className='flex gap-[1rem]'>
            <button
              onClick={handleSubmit}
              className="mt-6 bg-black text-white px-[1rem] py-3 rounded-xl hover:bg-gray-800 transition-all duration-300"
            >
              Submit Quiz
            </button>

            <button
              onClick={() => navigate('/quiz')}
              className="mt-6 bg-gray-600 text-white px-[1rem] py-3 rounded-xl hover:bg-gray-700 transition-all duration-300"
            >
              Back to Quiz
            </button>
          </div>

        </div>
      </div>
    </div>
  )
}

export default AttemptQuiz
